<!--模板管理-消息模板 -->
<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea InfoTemplate">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <BreadCrumb></BreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        
        <!-- 添加按钮 -->
        <el-button type="primary" class="add" @click="operateDialogInfo('addTemplate')">添 加</el-button>
        <el-button type="primary" @click="toSmsLog">发送情况</el-button>
        <!-- 模板列表 -->
        <el-table
          class="templateList"
          v-loading="templateData.loading"
          :data="templateData.list"
          style="width: 100%">
          <el-table-column
            type="index"
            label="序号">
          </el-table-column>
          <el-table-column
            class-name="textAlignLeft"
            label="模板ID"
            prop="template_id"
            sortable
            width="170">
          </el-table-column>
          <el-table-column
            label="第三方模板ID"
            prop="third_part_id"
            width="150">
          </el-table-column>
          <el-table-column
            label="短信服务商"
            width="120">
            <template slot-scope="scope">
              <span>{{smsTypeList[scope.row.sms_type]}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="模板名称"
            prop="template_name">
          </el-table-column>
          <el-table-column
            label="模板内容"
            prop="template_content">
          </el-table-column>
          <el-table-column
            label="添加时间"
            prop="create_time">
          </el-table-column>
          <el-table-column
            label="状态"
            width="80">
            <template slot-scope="scope">
              <el-button type="text" @click="operateDialogInfo('changeState',scope.row)">{{scope.row.status === '1' ? '启用' : '禁用'}}</el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="100">
            <template slot-scope="scope">
              <el-button type="text" @click="operateDialogInfo('alterTemplate', scope.row)">修改</el-button>
              <el-button type="text" @click="operateDialogInfo('deleteMsg',scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        
        <!-- 分页 -->
        <div class="paging" v-if="templateData.pageCount > 1">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="templateData.paging.page"
            layout="prev, pager, next, jumper"
            :page-count="templateData.pageCount">
          </el-pagination>
        </div>

        <!--对话框-->
        <el-dialog
          :title="dialogData.title" 
          :visible.sync="dialogData.visible"
          :show-close="dialogData.title === '' ? false : true">
          
          <!-- 添加/修改模板 -->
          <div v-if="dialogData.type == 'addTemplate' || dialogData.type == 'alterTemplate'">
            <el-form
              label-width="110px"
              :model="dialogData.info">
              <el-form-item label="第三方模板ID:">
                <!-- <div class="inputBox"> -->
                <el-input class="inputDeposit" v-model="dialogData.info.third_part_id"></el-input>
                <!-- </div> -->
              </el-form-item>
              <el-form-item label="模板名称:">
                <!-- <div class="inputBox"> -->
                <el-input class="inputDeposit" v-model="dialogData.info.template_name"></el-input>
                <!-- </div> -->
              </el-form-item>
              <el-form-item label="模板内容:">
                <!-- <div class="inputBox"> -->
                <el-input class="inputDeposit" v-model="dialogData.info.template_content" type="textarea" :rows="5"></el-input>
                <!-- </div> -->
              </el-form-item>
              <el-form-item label="短信服务商:">
                <el-select class="db" v-model="dialogData.info.sms_type">
                  <el-option label="请选择短信服务商" value="0"></el-option>
                    <el-option :label="item" :value="index" v-for="(item, index) in smsTypeList" :key="index"></el-option>
                  <!-- <el-option label="蜂助手" value="1"></el-option>
                  <el-option label="云通讯" value="2"></el-option> -->
                </el-select>
              </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="updateTemplate()">确 认</el-button>
            </div>
          </div>

          <!-- 修改模板状态 -->
          <div v-else-if="dialogData.type == 'changeState'">
            <p class="text">
              当前模板状态为
              <span class="bold">
                {{dialogData.info.status === '1' ? '开启' : '禁用'}}
              </span>
            </p>
            <p class="text">
              是否将状态改为
              <span class="bold">
                {{dialogData.info.status === '1' ? '禁用' : '开启'}}？
              </span>
            </p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogData.visible = false">取 消</el-button>
              <el-button @click="changeUserStatus()">{{dialogData.info.status === '1' ? '禁用' : '开启'}}</el-button>
            </div>
          </div>

          <!-- 删除模板 -->
          <div v-else>
            <p class="text">
              删除
              <span class="bold">
                {{dialogData.info.template_name}}
              </span>
              模板？
            </p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogData.visible = false">取 消</el-button>
              <el-button @click="deleteDeviceApi()">确认</el-button>
            </div>
          </div>

        </el-dialog>

      </div>
  </div>
</template>

<script>
  import BreadCrumb from "../../Layout/BreadCrumb.vue"
  import { templateApi } from "../../../../static/js/api.js"
  import { showToast, deepCopy,updataBreadCrumb } from '../../../../static/js/utility/utility';

  export default {
    name: 'InfoTemplate',
    components: {
      BreadCrumb
    },
    data() {
      return {
        // 短信类型列表
        smsTypeList: {
          '1': '蜂助手',
          '2': '云通讯',
          '3': '移动短信',
          '4': 'Twilio'
        },
        // 对话框数据
        dialogData:{
          type: '',
          title: '',
          visible: false,
          info: {}
        },
        // 分类数据
        categoryData: {
          // 分类列表
          // list: [{children: []}],
          list: [],
          loading: false,
          // 当前选中分类
          selected: '',
          // 配置类型列表
          typeList: [
            {
              name: '柜类',
              type: '1'
            },
            {
              name: '门禁',
              type: '2'
            },
            {
              name: '机器人',
              type: '3'
            }
          ],
        },
        // 模板数据
        templateData: {
          checked: false,
          // 分页数据  page为当前页，perPage为每页数量 ,state为服务器状态,1显示服务器启用状态,不填则显示全部
          paging: {
            page: 1,
            perPage: 10,
            category_id: '',
            template_type: '1'
          },
          // 短信列表
          list:[],
          loading: false,
        },
        // 树形控件配置
        defaultProps: {
          children: 'children',
          label: 'category_name'
        },
      }
    },
    mounted(){
      
    },
    created: async function () {
      this.getTemplateList()
    },
    methods: {
      //删除模板
      async deleteDeviceApi(){
        let that = this;
        const dataObj = {
          'template_id': that.dialogData.info.template_id
        }
        const res = await templateApi.deleteTemplate(dataObj)
        if(res.meta.code == 200){
          showToast('删除成功！')
          that.dialogData.visible = false
          that.getTemplateList()
        }else{
          showToast(res.meta.message)
        }
      },
      //修改模板状态
      async changeUserStatus(){
        let that = this;
        const dataObj = {
          'template_id': that.dialogData.info.template_id
        }
        const res = await templateApi.changeTemplateStatus(dataObj)
        if(res.meta.code == 200){
          showToast('状态修改成功！')
          that.dialogData.visible = false
          that.getTemplateList()
        }else{
          showToast(res.meta.message)
        }
      },
      //跳转到短信记录
      toSmsLog(){
        let that = this;
        let navBarActive = [{function_tab: 'smsLog', function_name: '短信记录'}]
        // 更新面包屑内容
        updataBreadCrumb(3, navBarActive)
        this.$router.push({
          path: '/smsLog',
        })
      },
      // 当前页值改变，获取新的模板列表
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.getTemplateList()
      },
      // 获取模板列表
      getTemplateList: async function () {
        let vm = this
        let data = vm.templateData.paging
        console.log('模板请求data', data)
        
        vm.templateData.loading = true
        let res = await templateApi.getTemplateList(data)
        vm.templateData.loading = false
        if (res.meta.code === 200) {
          vm.templateData.pageCount = res.data.pageCount
          vm.templateData.list = [...res.data.list]
        } else {
          showToast(res.meta.message)
        }
      },
      // 更新（新增/修改）模板
      updateTemplate: async function () {
        let vm = this
        console.log('vm.dialogData.info',vm.dialogData.info)
        let data = {
          third_part_id: vm.dialogData.info.third_part_id,//第三方模板ID
          template_id: vm.dialogData.info.template_id,//模板id
          template_name: vm.dialogData.info.template_name,//模板名称
          template_content: vm.dialogData.info.template_content,//模板内容
          flag: vm.dialogData.info.flag ? vm.dialogData.info.flag : 'edit',
          sms_type: vm.dialogData.info.sms_type,//短信服务商
          template_type:'1',
        }

        // 判断
        if (data.template_name == '') {
          showToast('请填写模板名称！')
          return
        }
        if (data.third_part_id == '') {
          showToast('请填写第三方模板ID！')
          return
        }
        if (data.sms_type == '0') {
          showToast('请选择短信服务商！')
          return
        }

        let res = await templateApi.updateTemplate(data)
        if (res.meta.code === 200) {
          showToast(data.template_id === '' ? '添加成功' : '修改成功')
          vm.dialogData.visible = !(vm.dialogData.visible)
          vm.getTemplateList()
        } else {
          showToast(res.meta.message)
        } 
      },
      
      // 操作对话框信息（添加或修改）dialogData
      operateDialogInfo: function (type, info) {
        
        // 添加模板信息
        let addTemplateInfo = {
          template_id: '',
          template_name: '',
          template_content: '',
          flag: 'add',
          sms_type:'0',
          third_part_id:'',
        }

        let title = type === 'addTemplate' ? '添加模板' :
                    type === 'alterTemplate' ? '修改模板' : ''
        this.dialogData = {
          type: type,
          title: title,
          visible: !(this.dialogData.visible),
          isReset: false,
          info: type === 'addFirstClass' || type === 'addClass' ? addClassInfo :
                type === 'addTemplate' ? addTemplateInfo : deepCopy(info)
        }
        console.log(this.dialogData)
      },
    },
    watch: {
      
    }
  }
</script>

<style lang="scss" scoped>
.InfoTemplate {
  .mainBodyContent{
    position: relative;
    .db{
      display: block;
    }
    .addBtn {
      margin-bottom: 10px;
    }
    .apiBox {
      .searchBox {
        .selectApiList {
          float: left;
          margin-right: 30px;
        }
        .addBtn {
          float: left;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/TemplateManage/InfoTemplate.vue